import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(
    private http: HttpClient,
  ) { }

  api = 'https://www.cotalker.com';

  getToken(email: string, password: string) {
    return this.http.post<{ token: string }>(`${this.api}/auth/local`, {
      email,
      password,
    });
  }

}
